import {request} from "../../utils/apiUtils";
import {URL_API} from "../../url.config";

let QltsUserController = {
    getList: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/user/list`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    create: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/campaign/create`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    edit: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/campaign/edit`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    detail: (campaignId, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/campaign/detail/${campaignId}`,
            method: 'GET',
        }, callback)
    },
    delete: (campaignId, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/campaign/delete/${campaignId}`,
            method: 'GET',
        }, callback)
    },
    createCustomerPayment: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/user/create-customer-payment/`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
    editCustomerPayment: (payload, callback) => {
        return request({
            url: `${URL_API}/api/sas-qlts/user/edit-customer-payment/`,
            method: 'POST',
            body: {
                ...payload,
            },
        }, callback)
    },
}

export default QltsUserController
